import React, { Component } from "react";
import "./App.css";
import { Title } from "./components/title";
import { Form } from "./components/form";
import { Weather } from "./components/weather";
import { Grid, Cell } from "react-mdl";

const API_KEY = "288fd7af46824d19f6871a8646d71e9e";
/*const Link = `http://api.openweathermap.org/data/2.5/weather?q=Manchester,uk&appid=288fd7af46824d19f6871a8646d71e9e&units=metric`; */

class App extends Component {
  state = {
    temperature: undefined,
    city: undefined,
    country: undefined,
    humidity: undefined,
    description: undefined,
    error: undefined
  };

  getWeather = async e => {
    e.preventDefault();

    const city = e.target.elements.city.value;
    const country = e.target.elements.country.value;
    const api_call = await fetch(
      `https://api.openweathermap.org/data/2.5/weather?q=${city},${country}&appid=${API_KEY}&units=metric`
    );
    const data = await api_call.json();

    if (city && country) {
      console.log(data);
      this.setState({
        temperature: data.main.temp,
        city: data.name,
        country: data.sys.country,
        humidity: data.main.humidity,
        description: data.weather[0].description,
        error: ""
      });
    } else {
      this.setState({
        temperature: undefined,
        city: undefined,
        country: undefined,
        humidity: undefined,
        description: undefined,
        error: "Please enter a value"
      });
    }
  };

  render() {
    return (
      <div className="app-body">
        <Grid noSpacing className="app-grid">
          <Cell col={5} tablet={6} className="app-title-cell">
            <Title />
          </Cell>
          <Cell col={7} tablet={6} className="app-weather-cell">
            <Form getWeather={this.getWeather} />
            <Weather
              temperature={this.state.temperature}
              city={this.state.city}
              country={this.state.country}
              humidity={this.state.humidity}
              description={this.state.description}
              error={this.state.error}
            />
          </Cell>
        </Grid>
      </div>
    );
  }
}

export default App;
